module.exports = __webpack_public_path__ + "static/img/p_01.9b46434.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/p_01.png
// module id = 755
// module chunks = 1